import { render, staticRenderFns } from "./CourseOverviewPage.vue?vue&type=template&id=728e639a&scoped=true"
import script from "./CourseOverviewPage.vue?vue&type=script&lang=js"
export * from "./CourseOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./CourseOverviewPage.vue?vue&type=style&index=0&id=728e639a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728e639a",
  null
  
)

export default component.exports